<template>
  <transition name="fade">
    <Notification v-if="popupShown" medium>
      <template v-slot:heading>
        {{ verificationError ? 'Whoops' : 'Success!' }}
      </template>
      <template v-slot:message>
        {{
          verificationError ?
            'We could not verify your email address. Please, try one more time' :
            'You have successfully verified your email. Now you can send invitations to attendees and update account details.'
        }}
      </template>
      <template v-slot:button>
        <div v-if="verificationError">
          <div class="flex items-center">
            <LoadingButton
              :loading="false"
              class="btn-primary px-6 ml-2"
              @click="popupShown = false; $router.push('/account'); window.location.reload()"
            >
              Ok
            </LoadingButton>
          </div>
        </div>
        <button
          v-if="!verificationError"
          type="button"
          class="btn btn-primary font-semibold rounded-lg px-16"
          @click="popupShown = false; $router.push('/account'); window.location.reload()"
        >
          Continue
        </button>
      </template>
    </Notification>
    <LoadingOverlay v-if="loading">
      <template v-slot:heading>
        Verifying your email...
      </template>
    </LoadingOverlay>
  </transition>
</template>

<script>
  import Notification from "../../components/Notification"
  import LoadingButton from "../../components/common/LoadingButton"
  import LoadingOverlay from "../../components/common/LoadingOverlay"
  import Api from "@/api"

  export default {
    name: "AccountVerification",
    components: {LoadingOverlay, LoadingButton, Notification},
    data() {
      return {
        popupShown: false,
        verificationError: false,
        loading: false,
      }
    },
    mounted() {
      this.loading = true
      Api.verifyEmail(
        this.$route.params.id,
        this.$route.query.expires,
        this.$route.query.hash
      ).then(() => {
        this.loading = false;
        this.popupShown = true;
      }).catch(() => {
        this.loading = false;
        this.popupShown = true;
        this.verificationError = true;
      })
    }
  }
</script>
